import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { OrganizationMemberLabel } from "@components/organizationView/shared/OrganizationMemberLabel";
import { AuditLog } from "@common/types/auditLog";
import { getOrganizationActivityInviteEmail } from "../describeOrganizationActivity";

export type OrganizationActivityMemberRow = Pick<
    AuditLog,
    "resourceType" | "resourceId" | "diff"
>;

interface MemberCellProps {
    row: { original: OrganizationActivityMemberRow };
}

export const MemberCell = memo(({ row }: MemberCellProps) => {
    const inviteEmail = getOrganizationActivityInviteEmail(row.original);
    const userDiff = row.original.diff.find(({ field }) => field === "userId");
    const fallbackMemberLabel =
        userDiff?.after.valueLabel ?? userDiff?.before.valueLabel;

    return (
        <ViewTableCell>
            {inviteEmail ?? (
                <OrganizationMemberLabel
                    userId={row.original.resourceId}
                    fallbackLabel={fallbackMemberLabel}
                />
            )}
        </ViewTableCell>
    );
});

MemberCell.displayName = "MemberCell";
